import { Box, Typography } from '@mui/material';
import React from 'react';
import { FONT_FAMILIES } from './constants';
import { FontFamily } from './types';
import TypographyAutocomplete from './TypographyAutocomplete';

type Props = {
	fontFamilies: FontFamily[];
	setFontFamily: (idx: number, value: FontFamily) => void;
};

export default ({ fontFamilies, setFontFamily }: Props) => (
	<Box>
		<Box padding={3}>
			<Typography marginBottom={1} variant="body1" color="text.secondary">
				{intl.tr('styleEditor.typography.fonts.title')}
			</Typography>
		</Box>
		<Box
			display="flex"
			padding={3}
			paddingTop={0}
			alignItems="center"
			sx={{ '> *': { marginRight: 4 } }}
		>
			<Box>
				<Typography marginBottom={1} variant="body1" color="text.secondary">
					{intl.tr('styleEditor.typography.fonts.subtitle')}
				</Typography>
			</Box>
			{fontFamilies?.map((fontFamily, i) => (
				<TypographyAutocomplete
					data-testid={`typography-font-family-${i}`}
					options={FONT_FAMILIES.map((family) => family.label)}
					value={fontFamily.label}
					setValue={(value) => {
						setFontFamily(
							i,
							FONT_FAMILIES.find((family) => family.label === value)!
						);
					}}
					// eslint-disable-next-line react/no-array-index-key
					key={fontFamily.label + i}
				/>
			))}
		</Box>
	</Box>
);
